import {createContext, useState } from "react";


export const SidebarContext = createContext();
export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const show = () => setIsSidebarOpen(true);
  const hide = () => setIsSidebarOpen(false);

  return (
    <SidebarContext.Provider value={{ isSidebarOpen, show, hide }}>
      {children}
    </SidebarContext.Provider>
  );
};

